<template>
    <div ref="BigMain" @scroll="scrollEvent">
        <navigation-bar Close/>

        <div class="tabs" @scroll="handleScrollTab" ref="tab" v-show="isShowTab">
            <div @click="toSlide(index)" :class="{active : tabNum===index}" v-for="(item , index) in typeList" :key="index">
                {{item.typeName}}
            </div>
        </div>
        <div class="main">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="(item , index) in typeList" :key="index">
                    <!-- 當 key的數值變動，元件就會重新 render -->
                    <div class="swipe-content" ref="swipe" @scroll="handleScroll(index)" :key="hotArticleKey[index]">
                        <!-- 使用迴圈要注意，若直接使用 hotArticleList[index] 這種寫法，即使陣列內容有變動，但因陣列指標不變的關係-->
                        <!-- article-card元件會當做內容沒有變化，元件不會刷新，造成陣列內容更動，但螢幕上的資料不會更新 -->
                        <!-- article-card :list="hotArticleList[index]"/ -->
                        <article-card :list="hotArticleList[index]"/>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <toast/>
    </div>
</template>


<script>
    import ArticleCard from '../../components/category/ArticleCard'
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    let vm = null;

    export default {
        name: "ArticleList",
        components: {
            Swiper,
            SwiperSlide,
            ArticleCard,
            Toast,
        },
        data() {
            return {
                // 用 ?判斷時，可能爲 falsy 的表達式有 null, NaN, 0, 空字串 ("") 和 undefined，如果 0是有用到的，不要用問號判斷
                storeId: this.$route.query.id, //? this.$route.query.id: 0,
                //熱門文章分類
                typeList: [],
                //熱門文章
                hotArticleList: [],
                hotArticleOffset: [],
                hotArticleKey: [],
                //是否是從首頁來的？
                isFromHomePage: false,
                //是否要顯示上方標籤頁
                isShowTab: true,
                //是否要增加 "總覽" 的項目
                isAddOverview: true,

                //目前選到的 tab的索引值
                tabNum: 0,

                //typeId、oinArticleTypeId 是取得文章列表 api用的
                //一般店家: 帶storeId, typeId, oinArticleTypeId=-1 取得文章列表
                //首頁: 帶storeId=0, typeId=-1, oinArticleTypeId 取得文章列表
                //其他: typeId=0, oinArticleTypeId=0
                //目前的 typeId
                typeId: this.$route.query.typeId,
                //目前的 oinArticleTypeId
                oinArticleTypeId: this.$route.query.oinArticleTypeId,
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                            vm.setupData(vm.tabNum);
                        },
                    }
                },
                //記憶捲動位置
                scroll: [],
                scrollTab: 0,
            }
        },
        created() {
            vm = this;
        },
        mounted() {
            //判斷是否有帶參數
            this.storeId = this.$public.notNull(this.storeId)? this.storeId: 0;
            this.typeId = this.$public.notNull(this.typeId)? this.typeId: -1;
            this.oinArticleTypeId = this.$public.notNull(this.oinArticleTypeId)? this.oinArticleTypeId: -1;

            //如果是首頁的話
            this.isFromHomePage = this.$route.query.isFromHomePage? this.$route.query.isFromHomePage: false;

            let self = this;
            self.isLoading = true;
            self.callGetArticleTypeApi(self.storeId, self.isAddOverview)
                .then( () => {
                    self.tabNumber(self.tabNum);
                    self.setupData(self.tabNum);
                    self.toSlide(self.tabNum);
                })
                .catch( (error) => {
                    self.isLoading = false;
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });
        },
        activated(){

            //判斷是否有帶參數，依照 typeId參數來切換現在的 tab
            //不用 nextTick的原因是 keep-alive的狀態下在 activated內使用 this，無法存取變數
            //底下幾乎和 mounted一樣
            let self = this;
            setTimeout(() => {
                self.storeId = self.$public.notNull(self.storeId)? self.storeId: 0;
                self.typeId = self.$public.notNull(self.typeId)? self.typeId: -1;
                self.oinArticleTypeId = self.$public.notNull(self.oinArticleTypeId)? self.oinArticleTypeId: -1;

                //如果是首頁的話
                // self.isFromHomePage = self.$route.query.isFromHomePage? self.$route.query.isFromHomePage: false;
                let nowActivatedTabIndex = 0;
                self.typeList.forEach(function (value, index) {
                    //如果有type的類型是符合傳進來的 typeId的，就把預設 tab設在這裡
                    if (value.typeId === self.typeId) {
                        nowActivatedTabIndex = index;
                    }
                });

                //切換tab
                self.tabNumber(nowActivatedTabIndex);
                self.toSlide(nowActivatedTabIndex);
            }, 300)

            const fullWidth = window.innerWidth;
            if(fullWidth>=1024){
                //網頁版紀錄捲動位置
                this.$refs.BigMain.scrollTop = this.scroll[0];
            }else{
                //手機版紀錄捲動位置
                for (let i = 0; i < this.hotArticleList.length; i++) {
                    this.$refs.swipe[i].scrollTop = this.scroll[i]
                }
                this.$refs.tab.scrollTo(this.scrollTab , 0 )
            }
        },
        methods: {

            /** 根據傳入的 index(tab索引) 取得文章列表，更新列表資料 */
            setupData: function (index) {
                let self = this;
                self.isLoading = true;

                //如果是首頁的話，參數要改變
                let typeId = self.typeId, oinArticleTypeId = self.oinArticleTypeId;
                if (self.isFromHomePage) {
                    typeId = -1;
                    oinArticleTypeId = self.typeId;
                }

                self.callGetArticleListApi(self.storeId, self.hotArticleOffset[index], typeId, oinArticleTypeId)
                    .then( () => {
                        self.isLoading = false;
                        //更新 key的數值和使用 $forceUpdate強制更新畫面，才可以解決陣列的內容更新，但元件畫面沒有重刷的問題
                        self.hotArticleKey.forEach(function (value, index) {
                            self.hotArticleKey[index]++;
                        });
                        self.$forceUpdate();
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 呼叫 取得文章類型列表 api */
            callGetArticleTypeApi (storeId, isAddOverview) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`ArticleTypeList${{
                        storeId: storeId,
                        isAddOverview: isAddOverview,
                    }} ${ json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data)) {
                            self.typeList = json.data;

                            self.typeList.forEach(function (value, index) {
                                if (!self.$public.notNull(self.hotArticleList[index])) {
                                    //一個 tab代表一種 type的文章陣列
                                    //清空各 tab的文章陣列
                                    self.hotArticleList[index] = [];
                                    //把 key和 Offset設爲 0， Key陣列是爲了讓元件可以強制重繪用的
                                    self.hotArticleKey[index] = 0;
                                    self.hotArticleOffset[index] = 0;
                                }

                                //如果有type的類型是符合傳進來的 typeId的，就把預設 tab設在這裡
                                if (value.typeId === self.typeId) {
                                    self.tabNum = index;
                                }

                            });

                            resolve();

                        } else {
                            reject(`GetStoreInfoById: 無法取得資料`);
                        }
                    }}`;
                });
            },

            /** 呼叫 取得文章列表 api
             * @param typeId: 要撈的文章的分類Id, 若要撈全部給-1，沒給值的話預設為0(其他)
             * @param oinArticleTypeId: 要撈的文章的上架分類id, 若要撈全部給-1，沒給值的話預設為0(其他)，基本上都是 -1
             * */
            callGetArticleListApi (storeId, offset, typeId, oinArticleTypeId) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`HotArticleList${{
                        storeId: storeId,
                        offset: offset,
                        typeId: typeId,
                        oinArticleTypeId: oinArticleTypeId,
                    }} ${ json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data) && json.data.length > 0) {
                            self.hotArticleList[self.tabNum].tmz_load_push(...json.data);
                            self.hotArticleOffset[self.tabNum]++;
                        }

                        resolve();
                    }}`;
                });
            },

            toSlide (index) {
                this.$nextTick(() => {
                    this.$refs.mySwiper.$swiper.slideTo(index);
                })
                this.scrollType();
            },
            tabNumber (index) {
                this.tabNum = index;
                this.typeId = this.typeList[index].typeId;
                this.scrollType();
            },
            //上方相對應的主題分類要捲動到中間
            scrollType () {
                setTimeout(() => {
                    document.querySelector('.active').scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
                }, 100);
            },
            handleScrollTab () {
                //記憶分頁捲動位置
                this.$nextTick(() => {
                    this.scrollTab = this.$refs.tab.scrollLeft;
                })
            },
            handleScroll (index) {
                //記憶文章捲動位置
                this.$nextTick(() => {
                    this.scroll[index] = this.$refs.swipe[index].scrollTop;
                })
            },
            //捲動紀錄位置
            scrollEvent() {
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scroll[0] = this.$refs.BigMain.scrollTop;
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    @media(min-width: 1024px){
        .tabs{
            margin-bottom: 20px;
        }
    }
</style>